import store from '../store/index'
export const TranslationsUtils = {
  methods: {
    computeCaption (name, language) {
      return name && store.state.translation && store.state.translation[name] && store.state.translation[name][language] !== '' && store.state.translation[name][language] !== null ? store.state.translation[name][language] : name
    },
    computeReportableCaption (reportableNameVar, name, language) {
      const reportableName = store.state.requirements[reportableNameVar] ? store.state.requirements[reportableNameVar]['reportable_name'] : ''
      return reportableName ? (store.state.translation[reportableName] && store.state.translation[reportableName][language] !== '' ? store.state.translation[reportableName][language] : reportableName) : (store.state.translation[name] && store.state.translation[name][language] !== '' ? store.state.translation[name][language] : name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/Translations.js